<template>
  <div>
    <div class="weeklytopic_headerttt">
      <p><img src="@/assets/img/reuter_header_logo.jpg" border="0" /></p>
    </div>
    <div class="weeklytopic_text">
      <h1>
        REUTERS News <br class="br" />
        (비즈니스/금융)
      </h1>
      <h2>
        REUTERS 통신에서 제공하는 세계 각국의 <br class="br" />최근 뉴스
        컨텐츠를 TOPIC으로 <br class="disbr" />활용함으로써 다양한
        <br class="br" />학습방법을 제공해 드립니다. <br />
        최신 비즈니스, 금융 뉴스 기사만 모아 비즈니스 트렌드와
        <br class="br" />영어를 동시에 <br class="disbr" />학습하세요.
      </h2>
    </div>
    <div class="weekly_Wrap">
      <ul>
        <li v-for="(item, index) of newsList" :key="index" class="toplist">
          <a style="cursor:hand" @click="goPopPage(item.newsSeq)"
            ><img :src="item.imgFile1" border="0"
          /></a>
          <a style="cursor:hand" @click="goPopPage(item.newsSeq)">
            <p class="top_engtitle">{{ index + 1 }}. {{ item.engTitle }}</p>
            <!-- <p class="top_newscode">[{{item.newsCode}}]</p> -->
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import he from "he";
export default {
  comments: {
    he
  },
  data: () => ({
    newsList: [],
    newsSeq: "",
    imgFile1: "",
    imgFile2: "",
    engTitle: "",
    newsCode: "",
    //url: 'https://www.carrotenglish.com', // 네이버 오브젝트 쪽으로 변경해줘야 함
    url: "https://kr.object.ncloudstorage.com" // 네이버 오브젝트 쪽으로 변경해줘야 함
  }),

  computed: {},

  mounted() {
    this.getNewsList();
  },

  methods: {
    day(index) {
      let dayNum = index + 1;
      let day = "";
      if (dayNum <= 6) {
        if (dayNum === 1) {
          day = "1.";
        } else if (dayNum === 2) {
          day = "2.";
        } else if (dayNum === 3) {
          day = "3.";
        } else if (dayNum === 4) {
          day = "4.";
        } else if (dayNum === 5) {
          day = "5.";
        } /* else if (dayNum === 6) {
          day = '토(Sat)'
        } else if (dayNum === 7) {
          day = '일(Sun)'
        } */
      }
      return day;
    },
    getNewsList: function() {
      this.axios
        .get("/v1/api/news/finance_reuters")
        // this.axios.get('/v1/api/news/reuters')
        .then(res => {
          if (res.data.err === 0) {
            this.newsList = res.data.newsList;
            this.newsList.map(value => {
              if (
                value.imgFile1 === undefined ||
                value.imgFile1 === "null" ||
                value.imgFile1 === null
              ) {
                value.imgFile1 = this.url + "/img/" + "topic_nopic_01.gif"; // 네이버 오브젝트에 추가 해줘야됨
              } else {
                value.imgFile1 = this.url + "/reuters/image/" + value.imgFile1;
              }
              value.engTitle = he.decode(value.engTitle);
              return value;
            });
          }
        })
        .catch(err => {
          console.error("err", err);
          if (err.response.data.path === "/login/msg") {
            alert("세션이 끊어졌습니다. 로그인 페이지로 이동합니다.");
            this.$router.push("/login");
          } else {
            alert("관리자에게 문의하세요");
          }
        });
    },

    goPopPage(newsSeq) {
      let userAgent = this.detectMobileDevice(window.navigator.userAgent);
      if (userAgent) {
        this.$router.push(`/cafe/pop_news_learn_recommend?news_seq=${newsSeq}`);
      } else {
        window.open(
          `/cafe/pop_news_learn_recommend?news_seq=${newsSeq}`,
          "news_pop",
          "width=1000,height=750,scrollbars=yes"
        );
      }
    },

    detectMobileDevice(agent) {
      const mobileRegex = [
        /Android/i,
        /iPhone/i,
        /iPad/i,
        /iPod/i,
        /BlackBerry/i,
        /Windows Phone/i
      ];

      return mobileRegex.some(mobile => agent.match(mobile));
    }
  }
};
</script>
<style scoped>
@import "../../assets/scss/weekly_topic.css";
/*@import '../../assets/scss/mediaboxAdvBlack.css';*/
</style>



// WEBPACK FOOTER //
// src/pages/cafe/popBizReuters.vue